<template>
  <div>
     <!-- <div class="current-settings">當前設置的顏色為: {{ operation.sgroupcolor }}</div>
     <div class="current-background" :style="{background:operation.sgroupcolor,height:'20px',width:'40px'}"></div> -->
     <div :style="{ marginTop: '2px' }">
           <!-- <a-radio-group   button-style="solid" @change="handleRadioGroupChange">
               <a-radio-button  button-style="solid" :style="{background:item.sgroupcolor}" v-for="item in sgrouplist"  :value="item.syssgid" :key="item.syssgid">
               {{ item.sgroupname }}
             </a-radio-button>
           </a-radio-group> -->
          <div class="current-background" @click="handleCheckSeatGroup(item)"  v-for="item in sgrouplist" :key="item.syssgid"   :style="{background:item.sgroupcolor}"> {{ item.sgroupname }}</div>
      
          <div class="current-settings" style="margin-left: 100px;">當前設置的座位分組為:</div>
     <div class="current-background" :style="{background:selectedSeatGroup.sgroupcolor}">{{selectedSeatGroup.sgroupname}}</div>
  

     <a-dropdown  style="float: right;">
            <template #overlay>
              <a-menu >
                <a-menu-item key="1" @click="handleAddGroup">新增分組</a-menu-item>
                <a-menu-item key="2" @click="handleEditGroup">修改分組</a-menu-item>
                <a-menu-item key="3" @click="handleDelGroup">刪除分組</a-menu-item>
              </a-menu>
            </template>
            <a-button >
              設定分組
              <a-icon type="down" style="margin-left: 8px"/>
            </a-button>
          </a-dropdown>
       
     
       </div>
   
    
   <a-tabs  hide-add :active-key="activeKey" @change="handleClickTab">
     <a-tab-pane v-for="pane in FloorAreaList" forceRender="true" :key="pane.sysfloorid" :tab="pane.floorname" :closable="pane.closable">
       <div :style="{ marginTop: '5px' }">
           <a-radio-group :defaultValue="active"  v-model:active="active" @change="handleAreaChange" button-style="solid">
               <a-radio-button  button-style="solid" v-for="item in pane.areas"  :value="item.sysareaid" :key="item.sysareaid">
               {{ item.areaname }}
             </a-radio-button>
           </a-radio-group>
           <div style="float: right;">
            <a-button style="margin-left: 8px" @click="SettingGroupSeatData('add')">設置座位分組</a-button>
            <a-button style="margin-left: 8px" @click="SettingGroupSeatData('del')">刪除座位分組</a-button>
          </div>
           <!-- <a-button style="float: right;" type="primary" >設置分區</a-button> -->
       </div>
       <div class="main">
         <div class="main-content">
             <div class="select-hbody">  
                 <div class="tdbody-line">
                   <div v-for="(item,pk) in maxcolqty" :key="pk"  @click="clickData('rows',maxrowqty,pk)" class="colno"> {{ pk+1 }}列</div>
                 </div>
             </div>
             
             <div class="tdbody-coln">
                   <div v-for="(item,hk) in maxrowqty" :key="hk"  @click="clickData('cols',hk,maxcolqty)" class="rowno"> {{ hk+1 }}排</div>
               </div>
             <div class="select-area" @mousedown="down" @mousemove="move" @mouseup="upan">
                 <div ref="movable" class="move" :style="myStyle"></div>
                 <div v-for="(item,index) in subset" :key="index" class="list">
                     <div v-for="(val,pk) in item" :key="pk" class="oplist">
                       <div
                         :ref="'seats_'+pane.sysfloorid"  :id="val.sysid" v-if="val.status=== '0'|| val.status === '3'|| val.status === '4'|| val.status === '5'"
                         :class="(selected.indexOf((pk+1)+(index*maxcolqty)) > -1)?'selected':''"
                         class="item" :style="{ border: bordersize + val.sgroupcolor }">
                         <!-- {{(pk+1)+(index*maxcolqty)}} -->
                       </div>
                       <div
                         :ref="'seats_'+pane.sysfloorid"  :id="val.sysid" v-else="val.status === '1' || val.status === '2'"
                         :class="(selected.indexOf((pk+1)+(index*maxcolqty)) > -1)?'selected':''"
                         class="emptyseat" >{{val.remark}}
                         <!-- {{(pk+1)+(index*maxcolqty)}} -->
                       </div>
                       
                       <!-- <div v-else-if="val.status==='2'" class="emptyseat"> {{val.remark}}</div>
                       <div v-else class="emptyseat"> {{val.remark}}</div> -->
                     </div>
                 </div>
             </div>
      

         </div>
       </div>
     </a-tab-pane>
   </a-tabs>
  
   <!-- <a-drawer  
     title="設置座位分區"
     placement="right"
     :closable="true"
     width="400px"
     :visible="drawervisible"
     @close="onClose"
 >
 <template>
   <j-form-container>
  
 <a-form-model layout="vertical"  :model="model" ref="form" :label-col="labelCol1" :wrapper-col="wrapperCol1"  :rules="validatorRules"  slot="detail">
       <a-row>
         <a-col :span="24">
           <a-form-model-item label="起始行"  prop="rownos">
             <a-input-number v-model="model.rownos" :min="1" :max="1000"  :disabled="rowdisabled" ></a-input-number>
             - <a-input-number v-model="model.rownoe" :min="1" :max="1000"   :disabled="rowdisabled"  ></a-input-number>
           </a-form-model-item>
         </a-col>
         <a-col :span="24">
           <a-form-model-item label="起始列" prop="colnos">
             <a-input-number v-model="model.colnos" :min="1" :max="1000" :disabled="coldisabled" ></a-input-number>
            - <a-input-number v-model="model.colnoe" :min="1" :max="1000"   :disabled="coldisabled"  ></a-input-number>
           </a-form-model-item>
         </a-col>
        
        
       </a-row>
     </a-form-model>
   </j-form-container>
   </template>
 <a-button style="margin-right: 8px" @click="onClose">关闭</a-button>
     <a-button type="primary" @click="handleSubmitForm">保存</a-button>
 </a-drawer> -->
 
 <seat-group-modal ref="modalForm" @ok="modalFormOk"></seat-group-modal>

  </div>

</template>
<script>

 import { httpAction, getAction,deleteAction } from '@/api/manageChooseSeat'
 import { getDictItemsFromCache } from '@/api/api'
 import { FormTypes,getRefPromise,VALIDATE_NO_PASSED } from '@/utils/JEditableTableUtil'
 import { JEditableTableModelMixin } from '@/views/chooseSeat/mixins/JEditableTableModelMixin'
 import { validateDuplicateValue } from '@/utils/util'
 
 import SeatGroupModal from './SeatGroupModal'

 function dataProces(areaData=null,infoList=null){
   if(!areaData || !infoList){
     return ;
   }
   let showlist = [];
   let subset = [];
   let maxrowqty  = 0;
   let maxcolqty = 0;
   areaData.forEach((item,index)=>{
     infoList.forEach((val,pk)=>{
       if(item.sysareaid==val.sysareaid){
         maxrowqty = item.maxrowqty;
         maxcolqty = item.maxcolqty;
         showlist.push(val);
       }
     })
   })
  if(showlist.length>0){
     for(let i=0;i<maxrowqty;i++){
       let attData = [];
       for(let j=0;j<maxcolqty;j++){
         let data = [];
         data = lineData(i,j,showlist);
         attData.push(data);
       }
       subset.push(attData);
     }
  }
 // console.log('座位数据:',subset)
  return subset;
 }
 //獲取區域數據
 function getArea(sysareaid=null,infoList=null){
   if(!sysareaid || !infoList){
     return ;
   }
   var arr = [];
   infoList.forEach((val,pk)=>{
     val.areas.forEach((item,index)=>{
         if(sysareaid==item.sysareaid){
           arr.push({
             maxrowqty:item.maxrowqty,
             maxcolqty:item.maxcolqty
           })
         }
     })
   })

 return arr;

 }
 function lineData(i=0,j=0,data=null){
   let retData = [];
   data.forEach((val,pk)=>{
       if(val.rowno===(i+1) && val.colno===(j+1) ){
         retData=val;
         return;
       }
   });
   return retData;
 }



 export default {
   name: 'SetGroupSeatForm',
   mixins: [JEditableTableModelMixin],
   inject:['operation'],
   components: {
    SeatGroupModal
   },
   data() {
     return {
       activeKey:'',
       active:'',
       selected : [],//被选元素的索引
       itemsData:[], //存储所有dom
       sgrouplist:[],
       selectedSeats:[],
       selectedSeatGroup:[],
       bordersize:'2px solid ',
       movable :{
         dom: null,
         top: 0,
         left: 0,
         width: 0,
         height: 0
       },
       myStyle:{
         top: 0,
         left: 0,
         width: 0,
         height: 0
       },
       point : { //鼠标起点坐标
         start: { x: 0, y: 0 },//鼠标终点坐标
         end: { x: 0, y: 0 },//是否正在move
         moving: false,//获取范围内四个角的坐标
       },
       // form 一行布局
       labelCol1: { span: 4 },
       wrapperCol1: { span: 18 },
       // form 两行布局， 默认为两行
       labelCol2: { span: 8 },
       wrapperCol2: { span: 12 },
       model:{
         sysid:"",
         sysactivityid:"",
         sysvenueid:"",
         sysareaid:"",
         sysfloorid:"",
         syssgid:"",
         rownos:"",
         rownoe:"",
         colnos:"",
         colnoe:""
       },
       url: {
         setSeat: "/SeatGroup/setSeatData",
         delete: "/SeatGroup/delete",
         list: "/SeatGroup/list",
         setGroupSeat: "/SeatGroup/settingGroupSeatData",
       },
       drawervisible:false,
       rowdisabled:false,
       coldisabled:false,
       FloorAreaList:[],
       maxrowqty:0,//行
       maxcolqty:0,//列
       sysfloorData:[],//默认楼层
       sysareaId:'',//默认区域
       sysfloorId:'',//默認樓層
       sysseatgroupid:'',//群組
       subset:[],//status  0  可选座位   (白色)1  已选座位   (绿色) 2  已购票座位 (红色) 3空座
      
     }
   },
   props: {
     //表单禁用
     disabled: {
       type: Boolean,
       default: false,
       required: false
     }
   },
   computed: {
     language() {
       return this.$store.getters.language
     },
     formDisabled() {
       return this.disabled
     },
     validatorRules() {
     if (this.language) {
       return {
         colnos: [
           {required: true, message: this.language['cs.input']+'起始列!'}
         ],
        
         rownos: [
             {required: true, message: this.language['cs.input']+'起始行!'}
           ]
       }
     }  
   }
   },
   created () { 
    this.loadSeatGroup();
     this.getFloorData(); 
   },
   watch: {
     movable:{
       handler(newValue, oldValue){// 数组发生变化时的处理逻辑
         this.myStyle.height = newValue.height
         this.myStyle.width = newValue.width
         this.myStyle.top = newValue.top
         this.myStyle.left = newValue.left
         //console.log('数组发生了变化1',newValue);
         //console.log('数组发生了变化2',oldValue);
       },deep: true // 深度监听数组的变化
     },

   },
   methods: {
    loadSeatGroup()
    { 
      let selectpara = {
        sysactivityid:this.operation.sysactivityid,
        sysvenueid:this.operation.sysvenueid
     
         };
      getAction(this.url.list, selectpara).then((res) => {
           if (res.success) {
            this.sgrouplist=res.result.records;
           
           }
          });
    },

     getFloorData(sysactivityid=this.operation.sysactivityid,sysvenueid=this.operation.sysvenueid){
         this.subset = [];
         this.selectedSeats=[];
         this.selected=[];
         this.itemsData=[];
         //加载默认楼层信息
         let selectvenue = {
           sysactivityid:sysactivityid,
           sysvenueid:sysvenueid
         };
         getAction('/SelectData/FloorAreaList', selectvenue).then((res) => {
           if (res.success) {
             //console.log('FloorAreaList接口数据：',res.result.records[0]);
             let floorList = [];
             floorList = res.result.records[0].fLoors;
             this.FloorAreaList = floorList;
             if(floorList){
               //console.log('FloorAreaList接口数据11：',areaList);
               this.sysfloorData = floorList[0];//当前楼层
               this.activeKey = floorList[0].sysfloorid;
               this.active = floorList[0].areas[0].sysareaid;
               this.sysareaId = floorList[0].areas[0].sysareaid;
               this.sysfloorId= floorList[0].sysfloorid;
               //取默认行列
                this.maxrowqty = floorList[0].areas[0].maxrowqty;//行
                this.maxcolqty = floorList[0].areas[0].maxcolqty;//列
               //查询默认楼层座位
               this.selectAreaSeatData();
             }
           }
         })
     },
     handleAreaChange(val){ //区域选择
      this.sysareaId=val.target.value;
      this.selectAreaSeatData()
      
     },
     // 綁定區域數據
     selectAreaSeatData()
     {
      this.selectedSeats=[];
      this.selected=[];
      this.itemsData=[]; 
      this.subset =[]; 
      this.active =this.sysareaId;
   
       console.log("this.active===",this.sysareaId)
       let areas = getArea(this.sysareaId,this.FloorAreaList);
       this.maxrowqty = areas[0].maxrowqty;
       this.maxcolqty = areas[0].maxcolqty;
       let selectparams = {
         sysactivityid:this.operation.sysactivityid,
         sysvenueid:this.operation.sysvenueid,
         sysareaId: this.sysareaId
       };
       getAction('/SelectData/ActivitySeatInfoList', selectparams).then((res) => {
           if (res.success) {
           // console.log("綁定區域數據",res.result.records)
             this.subset = dataProces(this.sysfloorData.areas,res.result.records);
             this.$nextTick(() => {
                     let seats = this.$refs[`seats_${this.sysfloorId}`]? this.$refs[`seats_${this.sysfloorId}`] : []
                     console.log("seat===",seats);
                       if (seats && seats.length > 0) {
                         for (let i = 0, l = seats.length; i < l; i++) {
                           this.itemsData[i] = {
                             selected: false,
                             dom: seats[i]
                           }
                         }
                       }
           })
           }
       })
     },
// 行列選中
     clickData(type,rowno,colno){
       this.selected = []; //清空被选的索引
       this.selectedSeats= [];
       if(type=="rows")
        {
              for(var i=0;i<rowno;i++)
              {
               
                let selectIndex=0;
                selectIndex=i*this.maxcolqty+colno
               
                this.itemsData.forEach((item, index) => {
                    if(index==selectIndex)
                    {
                      this.selectedSeats.push(item.dom.id);
                      this.selected.push(selectIndex+1);
                      item.selected = true;
                    }
                  })
              }
           
        }

       if(type=="cols")
        {   
            for(var i=0;i<colno;i++)
            {
              let selectIndex=0;
              selectIndex=rowno*this.maxcolqty+i
              this.itemsData.forEach((item, index) => {
                if(index==selectIndex)
                    {
                      this.selectedSeats.push(item.dom.id);
                      this.selected.push(selectIndex+1);
                      item.selected = true;
                    }
               })
            }
        }
        
       //console.log('选的索引12=:',this.selectedSeats);
     },
  
     handleSubmitForm () {
       const that = this;
       that.model.sysactivityid=that.operation.sysactivityid;
       that.model.sysvenueid=that.operation.sysvenueid;
       that.model.sysareaid=that.sysareaId;
       that.model.sysfloorid=that.sysfloorId;
       that.model.syssgid=that.sysseatgroupid;

       if(that.model.rownos=="" ||that.model.rownoe=="" ||that.model.rownos==""||that.model.rownoe=="")
       {
         that.$message.error("起始列與行不能為空");
         return;
       }

       if(that.model.rownos>that.maxrowqty ||that.model.rownoe>that.maxrowqty )
       {
         that.$message.error("行不能超過最大行數("+that.maxrowqty+")");
         return;
       }
       if(that.model.colnos>that.maxcolqty ||that.model.colnoe>that.maxcolqty )
       {
         that.$message.error("列不能超過最大列數("+that.maxcolqty+")");
         return;
       }
       if(that.model.rownos>that.model.rownoe)
       {
         that.$message.error("起始行輸入正確");
         return;
       }
       if(that.model.colnos>that.model.colnoe )
       {
         that.$message.error("起始列輸入正確");
         return;
       }
       // 触发表单验证
       that.$refs.form.validate(valid => {

         if (valid) {
           that.confirmLoading = true;
           httpAction(that.url.setSeat, that.model, 'post').then((res) => {
             if (res.success) {
               that.$message.success(res.message);
               that.$emit('ok');
               let selectparams = {
                 sysactivityid:that.operation.sysactivityid,
                 sysvenueid:that.operation.sysvenueid,
                 sysareaId:that.sysareaId
               };
               getAction('/SelectData/ActivitySeatInfoList', selectparams).then((res) => {
                   if (res.success) {
                     that.subset = dataProces(that.sysfloorData.areas,res.result.records);
                   }
               })
             } else {
               that.$message.warning(res.message);
             }
           }).finally(() => {
             that.drawervisible=false;
             that.confirmLoading = false;
           })
         }

       })
     },

     handleClickTab(key){ //楼层选择
     
       let tablist = this.FloorAreaList;
       let list =this.FloorAreaList.filter(item=>item.sysfloorid==key)
        if (list.length>0)
        {
          this.sysfloorData = list[0];
          this.activeKey = key
          this.sysfloorId=key
          if(list[0].areas.length>0){
                this.sysareaId=list[0].areas[0].sysareaid;
                this.active=list[0].areas[0].sysareaid;
                this.selectAreaSeatData();      
          }
        }
     console.log("this.active==",this.active);
      
     },
     SettingGroupSeatData(type){
      if(type=="add"&&this.sysseatgroupid=="")
      {
        this.$message.error("請選擇分組");
         return;

      }
      var seats=this.selectedSeats.join(',') 
     // console.log("seats==",seats);
      let postdata={
        "type":type,
        "sysIds":seats,
        "syssgid":this.sysseatgroupid
      }
      httpAction(this.url.setGroupSeat,postdata, 'post').then((res) => {
             if (res.success) {
              this.$message.success(res.message);
        
             } else {
              this.$message.warning(res.message);
             }
           })
           this.selectAreaSeatData();     
     },
     handleAddGroup(){
      this.$refs.modalForm.add();
      this.$refs.modalForm.title = "新增";
      this.$refs.modalForm.disableSubmit = false;
      this.operation.optiontype="add";
      this.operation.isshow=false;

     },
     handleEditGroup(){
      if(this.sysseatgroupid=="")
      {
        this.$message.error("請選擇分組");
         return;

      }   
            this.$refs.modalForm.edit(this.selectedSeatGroup);
            this.$refs.modalForm.title = "编辑";
            this.$refs.modalForm.disableSubmit = false;
            this.operation.optiontype="edit"; 
             this.operation.isshow=true;
     },
     handleDelGroup(){
      if(this.sysseatgroupid=="")
      {
        this.$message.error("請選擇分組");
         return;

      }
      deleteAction(this.url.delete, {id:  this.sysseatgroupid}).then((res) => {
        if (res.success) {
          //重新计算分页问题
          this.$message.success(res.message);
          this.loadSeatGroup();
          if(this.sysseatgroupid==this.selectedSeatGroup.syssgid)
          {
            this.selectedSeatGroup=[];
          }
        } else {
          this.$message.warning(res.message);
        }
      });
     },
     handleRadioGroupChange(val)
     {
      this.sysseatgroupid=val.target.value;
     },

     handleCheckSeatGroup(item)
     {
      this.sysseatgroupid=item.syssgid;
      this.selectedSeatGroup=item;
     },
     modalFormOk() {
      // 新增/修改 成功时，重载列表
      this.loadSeatGroup();
      if(this.selectedSeatGroup.length>0)
      {
        let selectpara = {
        sysactivityid:this.operation.sysactivityid,
        sysvenueid:this.operation.sysvenueid,
        syssgid:this.selectedSeatGroup.syssgid
     
         };
      getAction(this.url.list, selectpara).then((res) => {
           if (res.success) {
            this.selectedSeatGroup=res.result.records[0];
           
           }
          });
      }
     
    },
     pushData(dom, index){
       this.itemsData[index] = {
         selected: false,
         dom
       }; //记录dom
     },
 
     getPosition(){
       let angle = []; //角
         angle.push(this.point.start); //起点
         angle.push(this.point.end); //终点
         angle.push({
           x: this.point.end.x,
           y: this.point.start.y
         }); //对角
         angle.push({
           x: this.point.start.x,
           y: this.point.end.y
         }); //对角
       return angle;
   },
   //判断元素是否满足被选中的条件
     isSelected (rect) {
       let angle = this.getPosition(); //获取四个角的坐标
 
       //获取指定图形的四个坐标
       let rectangle = [
         {
           x: rect.x,
           y: rect.y
         },
         {
           x: rect.x + rect.width,
           y: rect.y + rect.height
         },
         {
           x: rect.x + rect.width,
           y: rect.y
         },
         {
           x: rect.x,
           y: rect.y + rect.height
         }
       ];
    
     //满足以下任意一个条件即可
     //互相判断
       for (let pos of rectangle) {
         if (pos.x > angle[0].x &&
             pos.x < angle[1].x &&
             pos.y > angle[0].y &&
             pos.y < angle[1].y) {
           return true;
         }
       }
       //互相判断
       for (let pos of angle) {
         if (pos.x > rectangle[0].x &&
             pos.x < rectangle[1].x &&
             pos.y > rectangle[0].y &&
             pos.y < rectangle[1].y) {
           return true;
         }
       }
     //相交检测（横）
       if (angle[0].x < rectangle[0].x &&
           angle[1].x > rectangle[1].x &&
           angle[0].y > rectangle[0].y &&
           angle[1].y < rectangle[1].y) {
         return true;
       }
     //相交检测（竖）
       if (angle[0].x > rectangle[0].x &&
           angle[1].x < rectangle[1].x &&
           angle[0].y < rectangle[0].y &&
           angle[1].y > rectangle[1].y) {
         return true;
       }
       return false;
     },

     down(e){//鼠标按下,记录初始点击的位置
       //console.log('鼠标按下:',e);
       this.point.start.x = e.x;
       this.point.start.y = e.y;
       //同步选择框的原点
       this.movable.left = e.x + "px";
       this.movable.top = e.y + "px";
       this.point.moving = true; //标记移动开始
       //console.log('鼠标按下:',this.movable);
     },
     move(e){// 鼠标移动
      // console.log('鼠标移动:',e);
       if (!this.point.moving) return;
       let {x, y} = e; //鼠标位置 //同步放大元素
       this.movable.height = Math.abs(this.point.start.y - y) + "px";
       this.movable.width = Math.abs(this.point.start.x - x) + "px";
      // console.log('鼠标移动:',this.movable);
     },
     upan(e){//没有移动，直接终止
       //console.log('没有移动，直接终止:',e);
       if (!this.point.moving) return;
       this.movable.width = 0;
       this.movable.height = 0;
       this.point.end.x = e.x;
       this.point.end.y = e.y;
       this.point.moving = false; //循环遍历元素是否被选中
       this.selected = []; //清空被选的索引
       this.selectedSeats= [];
       this.itemsData.filter((item) => item.selected == true).forEach((item) => { item.selected = false });//清空歷史選中數據
       console.log(" this.itemsData==", this.itemsData)
       this.itemsData.forEach((item, index) => {
     
           if (this.isSelected(item.dom.getBoundingClientRect())) {
            this.selected.push(index + 1);
            this.selectedSeats.push(item.dom.id);
            item.selected = true;
           }
         })
       console.log('选的索引 :',this.selected);
       
     }

   }
 }
</script>


<style scoped>
.current-settings{ display: inline-block;text-align: center;height:35px;}
.current-background{ display: inline-block;text-align: center;color: #fff;border: 1px solid #fff;width:90px;height:35px;line-height: 35px;margin-right: 5px;}
.main{float: left;width:100%;min-height:650px; overflow: scroll;background:#fff; margin-top:50px;}
.main-content{ float: left; min-height:450px;}
.list{float:left; width:100%; margin-left: 6px;display: flex;}
.oplist{float:left;height:30px;margin-bottom: 5px;}
.selection{display: flex;flex-direction: column; border: 1px solid #dcdcdc; text-align: center;line-height: 30px;width:60px;height:30px;background: #F2F2F2;margin:0px;}
.red{ background: #f00; color: #fff;}
.green{ background: #11df0dd9;}
.emptyseat{background:  #fff; display: flex;flex-direction: column;border: 1px solid #fff;width:60px;height:30px;margin:0px;margin-right: 5px;}
 
.select-hbody{display: flex;
    float: left;
    width: 100%;}
.tdbody-line{
    float: left;
    margin-left: 71px;
    margin-bottom: 10px;
    display: flex;
}
.tdbody-coln{ width: 65px;
    display: flex;
    float: left;
    flex-direction: column;}
 
.colno{float:left;width:60px; height:30px; margin-right: 5px; border: 1px solid #dcdcdc;  background: #EBFAF0; text-align: center;line-height:30px;}
.rowno{position: relative; width:60px; height:30px; margin-bottom: 5px;border: 1px solid #dcdcdc;  background: #FFF9E6;text-align: center;line-height:30px;}
.select-area{
  float: left;
  width: 90%;
  /* border: 1px solid #000000; */
  /* display: flex; */
  /* align-items: center; */
  /* flex-wrap: wrap; */
  /* justify-content: center; */
  /* position: relative;
  overflow: hidden; */
}
.select-area .item {
  display: inline-block;
  width:60px;
  height:30px;
  margin-right: 5px;
  text-align: center;
  /* background: #dcdcdc; */
  border: 1px solid #dcdcdc;
  user-select: none;
  }
.select-area .selected {  background-color: #81D3F8;}
.select-area .move{
  position: fixed;
  top: 100px;
  left: 200px;
  width: 80px;
  height: 100px;
  background: rgba(234, 23, 135, 0.3);
}
       
:deep(.ant-modal-body){
  padding:2px
}  
    
</style>